/**
 * ForcePasswordChange - erzwungener Passwortwechsel nach Login
 *
 * Integration-in-One Design (zentrierte Auth-Karte, .iio-Wrapper fuer Tokens).
 * Wird gerendert wenn user.mustChangePassword === true.
 */
import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../utils/helpers";
import { ThemeCtx } from "../theme/ThemeContext";

const ForcePasswordChange = ({ onDone }) => {
  const { t } = useTranslation("benutzer");
  const { theme } = useContext(ThemeCtx);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [ld, setLd] = useState(false);

  const go = async (e) => {
    e?.preventDefault?.();
    if (pw.length < 6) { setErr(t("passwort.zuKurz")); return; }
    if (pw !== pw2) { setErr(t("passwort.ungleich")); return; }
    setErr(""); setLd(true);
    try {
      await api("/api/auth/change-password", { method: "POST", body: JSON.stringify({ newPassword: pw }) });
      onDone();
    } catch (e) { setErr(e.message || t("passwort.fehler")); }
    setLd(false);
  };

  const labelStyle = { display: "block", fontSize: 10.5, fontWeight: 600, letterSpacing: ".1em", textTransform: "uppercase", color: "var(--iio-text-3)", marginBottom: 6 };
  const inputStyle = {
    display: "block", width: "100%", height: 42, padding: "0 14px",
    border: "1px solid var(--iio-border)", borderRadius: "var(--iio-r-sm)",
    background: "var(--iio-bg-1)", color: "var(--iio-text-1)", fontFamily: "inherit", fontSize: 14,
    outline: "none", boxSizing: "border-box",
    transition: "border-color var(--iio-transition-fast), box-shadow var(--iio-transition-fast)",
  };
  const onFocus = (e) => { e.target.style.borderColor = "var(--iio-brand-ink)"; e.target.style.boxShadow = theme === "dark" ? "0 0 0 3px rgba(90,154,224,.18)" : "0 0 0 3px rgba(10,61,74,.12)"; };
  const onBlur = (e) => { e.target.style.borderColor = "var(--iio-border)"; e.target.style.boxShadow = "none"; };
  const disabled = ld || !pw || !pw2;
  const submitBtn = {
    display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8,
    width: "100%", height: 44, padding: "0 20px", marginTop: 4,
    border: "1px solid transparent", borderRadius: "var(--iio-r-md)",
    background: "var(--iio-brand-ink)", color: "#FFFFFF", fontFamily: "inherit", fontSize: 14, fontWeight: 600,
    cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1,
    transition: "background var(--iio-transition-fast)",
  };

  return (
    <div className="iio" style={{ minHeight: "100vh", background: "var(--iio-bg-0)", color: "var(--iio-text-1)", fontFamily: "var(--iio-font-sans)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 420, animation: "fadeIn .4s ease" }}>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, letterSpacing: "-.02em" }}>{t("passwort.titel")}</h1>
          <p style={{ margin: "6px 0 0", fontSize: 14, color: "var(--iio-text-2)" }}>{t("passwort.untertitel")}</p>
        </div>

        <form onSubmit={go} style={{ background: "var(--iio-bg-2)", border: "1px solid var(--iio-border)", borderRadius: "var(--iio-r-xl)", boxShadow: "var(--iio-shadow-sm)", padding: 28 }}>
          {err && (
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16, color: "var(--iio-critical)", fontSize: 13 }}>
              <span style={{ width: 2, height: 13, background: "currentColor", display: "inline-block" }} />
              {err}
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <label htmlFor="fpc-pw" style={labelStyle}>{t("passwort.neu")}</label>
            <input id="fpc-pw" type="password" autoFocus value={pw} onChange={e => setPw(e.target.value)} placeholder={t("passwort.neuPlatzhalter")} autoComplete="new-password" style={inputStyle} onFocus={onFocus} onBlur={onBlur} />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label htmlFor="fpc-pw2" style={labelStyle}>{t("passwort.bestaetigen")}</label>
            <input id="fpc-pw2" type="password" value={pw2} onChange={e => setPw2(e.target.value)} placeholder={t("passwort.bestaetigenPlatzhalter")} autoComplete="new-password" style={inputStyle} onFocus={onFocus} onBlur={onBlur} />
          </div>
          <button type="submit" disabled={disabled} style={submitBtn}
            onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = "var(--iio-brand-ink-2)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "var(--iio-brand-ink)"; }}>
            {ld ? t("passwort.speichert") : t("passwort.setzen")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
